import { AodRule, ScheduledAodRunDto } from '@app/modules/audit/modules/aod/aod.types';
import { useAuditReportsGetAodScheduledRunsScheduledRunsForRule } from '@mi-front/api-v2';
import { MrtTable, NullState, QueryView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { createScheduledRunsColumns } from '../../../components/columns/ScheduledRunsColumns';

interface Props {
  rule: AodRule;
}

export function ScheduledRunsContent({ rule }: Props) {
  const { formatMessage } = useIntl();

  const scheduledRunsQuery = useAuditReportsGetAodScheduledRunsScheduledRunsForRule(rule.id);

  return (
    <QueryView query={scheduledRunsQuery}>
      {(scheduledRuns: ScheduledAodRunDto[]) => {
        if (!scheduledRuns || scheduledRuns.length === 0) {
          return (
            <NullState>
              {formatMessage({
                id: 'audit.aod.rules.view.runs.noFutureRuns',
                defaultMessage: 'No hay ejecuciones programadas para esta regla.',
              })}
            </NullState>
          );
        }

        return (
          <MrtTable<ScheduledAodRunDto>
            data={scheduledRuns}
            columns={createScheduledRunsColumns(formatMessage, {
              includeActions: true,
              includeRuleLink: false,
            })}
            enablePagination
            enableFilters
            enableGlobalFilter
            enableSorting
            enableExpandAll={false}
            memoizeColumns={false}
            enableHiding={false}
            enableColumnActions={false}
            globalFilterFn="includesString"
          />
        );
      }}
    </QueryView>
  );
}
